import React from "react";
import { Box, Typography, Chip } from "@mui/material";

const PreviewHero = ({ data }) => (
  <Box>
    <Typography variant="body2" fontWeight={700} sx={{ color: "#3b82f6" }}>
      {data.headlineLine1 || "—"}{" "}
      <span style={{ color: "#fff" }}>{data.headlineLine2}</span>
    </Typography>
    {data.subheadline && (
      <Typography
        variant="caption"
        color="text.secondary"
        display="block"
        mt={0.5}
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: 400,
        }}
      >
        {data.subheadline}
      </Typography>
    )}
    <Box display="flex" gap={1} mt={1}>
      {data.primaryCta && (
        <Chip
          label={data.primaryCta}
          size="small"
          sx={{ background: "#3b82f6", color: "#fff", fontSize: "10px" }}
        />
      )}
      {data.secondaryCta && (
        <Chip
          label={data.secondaryCta}
          size="small"
          variant="outlined"
          sx={{ fontSize: "10px" }}
        />
      )}
    </Box>
  </Box>
);

export default PreviewHero;